import React, { useState } from 'react';

import { DataTableAction } from 'components/DataTable';
import { ENTITY_EXPERIMENT } from 'constants/schemas';
import { ExperimentIcon } from 'constants/icon.constants';
import NewExperimentDialog from 'components/NewExperimentDialog';
import PropTypes from 'prop-types';
import { formatType } from 'utils/entity.utils';

function ActionAddExperiment(props) {
  const { initState } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const isTemplate = initState?.is_template;
  return (
    <>
      <DataTableAction
        label={`New ${formatType(ENTITY_EXPERIMENT, { template: isTemplate })}`}
        icon={<ExperimentIcon colored template={isTemplate} />}
        onClick={() => setDialogOpen(true)}
      />
      <NewExperimentDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initState={initState}
      />
    </>
  );
}

ActionAddExperiment.propTypes = {
  initState: PropTypes.object,
};

export default ActionAddExperiment;
